// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1iIUI","label":"Section_label__2pGJ8","contentWrap":"Section_contentWrap__34x0A","footer":"Section_footer__3Wb9-","footerInner":"Section_footerInner__2C8Vg"};